import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api";
import type { Schemas } from "../../api/types";
import { POLL_WATCH_MS } from "./intervals";

export type DashboardStats = Schemas["DashboardStats"];

export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: ["stats", "dashboard"],
    queryFn: () => apiGet<DashboardStats>("/stats/dashboard"),
    refetchInterval: POLL_WATCH_MS,
  });
}
